import React, { PureComponent } from 'react';
import { strings } from '../../localization';

const rules = [
    {name: "LengthLimits", pattern: /^.{8,80}$/, description: strings.formatString(strings.length_limits), met: false},
    {name: "RequireUppercase", pattern: /[A-Z]/, description: strings.formatString(strings.require_uppercase), met: false},
    {name: "RequireLowercase", pattern: /[a-z]/, description: strings.formatString(strings.require_lowercase), met: false},
    {name: "RequireNumbers", pattern: /[0-9]/, description: strings.formatString(strings.require_numbers), met: false},
    {name: "NoSpaces", pattern: /^[\S]*$/, description: strings.formatString(strings.no_spaces), met: false}
]

export default class PasswordPolicyChecklist extends PureComponent {
    constructor(props)
    {
        super(props);
    }

    allRulesAreMet(password){
        rules.forEach(rule => {
            rule.met = password.length > 0 && rule.pattern.test(password);
        });

        return rules.every(rule => rule.met);
    }

    componentWillUpdate(nextProps){
        this.props.onPolicyCheck(this.allRulesAreMet(nextProps.password));
    }

    render(){
        return (
        <section className="passwords-policy-checklist">
            {!this.props.noHeader &&
                <div className="passwords-policy-checklist-header"><h6>{strings.formatString(strings.passwords_must)}: </h6></div>
            }
            <div>
                <ul>
                {rules.map(rule => {
                    return <li className={"password-rule" + ( rule.met ? " password-rule-met" : "")} key={rule.name}>{rule.description}</li>
                })
                }
                </ul>
            </div>
        </section>
    )}
}